import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import { CompanyBuilder, LoadRosterOutput } from '../companies.types';

export const loadRoster = (builder: CompanyBuilder) =>
  builder.query<LoadRosterOutput, number>({
    query: (positionId) => ({
      url: `/candidate-position-status/custom-roster/${positionId}`,
      method: 'GET',
    }),
    providesTags: (result) =>
      result
        ? [
            ...result.map(({ id }) => ({ type: 'Company' as const, id })),
            { type: 'Company', Id: 'LIST' },
          ]
        : [{ type: 'Company', Id: 'LIST' }],
    transformErrorResponse(error) {
      errorHandler(
        '[loadCustomRoster]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.loadingCustomRoster
          : ErrorMessageEn.loadingCustomRoster,
        error,
        true
      );
    },
  });
